<template>
  <div class="application">
    <div class="row landing-1">
      <div class="col-md-6">
        <h1 class="title-landing">process page </h1>
      </div>
      <div class="col-md-6">
        <img :src="landing" style="width:70%;border-radius:2px;">
      </div>

        <!--
        <div class="col-md-3">
                        <li v-for="(item, k) in form">
                            <strong>{{ k }}:</strong> {{ item }}
                        </li>
        </div>
        -->
    </div>
  </div>
</template>

<script scoped>
export default {


    data() {
        return {
            landing: require('./assets/img/process/landing.svg'),
            form: {
                name:'',
                company:'',
                pitch:''

            }
        }
    },
computed: {
    getSVGFillColor () {
      return this.isActive ? this.activeFill : this.regularFill
    },
    getButtonBGColor () {
      return this.isActive ? this.regularFill : this.activeFill
    },
    getLabelColor () {
      return this.isActive ? this.activeFill : this.regularFill
    }
  },
  methods: {
    close_menu:function closeNav() {
      this.isActive = !this.isActive
    },
    svgReady () {
      console.log('svg is ready!!')
    }
  }

}





</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input-contact{
      box-sizing: border-box;
  display: block;
  width: 100%;
  height:50px;
  border-width: 1px;
  border-style: solid;
  border-color:white;
  padding: 16px;
  outline: 0;
  font-family: inherit;
  font-size: 0.95em;
  border-radius:3px;
  margin-top:10px;
}
.input-contact:focus{
  border-color:grey;    
}

.animated {
    -webkit-animation-duration: 10s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
}
    
@-webkit-keyframes fadeIn {
    0% {opacity: 0;}
    100% {opacity: 1;}
}
    
@keyframes fadeIn {
    0% {opacity: 0;}
    100% {opacity: 1;}
}
    
.fadeIn {
    -webkit-animation-name: fadeIn;
    animation-name: fadeIn;
}




.title-landing{
font-family: Avenir Next, sans-serif;
color:#;
font-size:30px;
font-weight:normal;
text-align:center;

}

.text-landing-1{

    width:100%;
}

.landing-1{
/* Rectangle 17: */
background-image: linear-gradient(-180deg, #FFFCF1 0%, #FFEDD4 100%);
height:900px;
width:100%;
margin-left:0px;
    padding-top:120px;
    text-align:center;
}

#zindex-neg{
    z-index:-2;
}

#zindex-pos{
 
}

.landing-2{
    background-color:white;
    height:900px;
}





.application{
background-color:white;
left:0;
margin:0;
}

</style>



// WEBPACK FOOTER //
// src/process.vue